<template>
  <div>
    <el-table :data="projectList">
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="coinType" label="申购币种"></el-table-column>
      <el-table-column prop="distributionCoinType" label="支持币种">
        <template slot-scope="scope">{{
          scope.row.supportCoin &&
            scope.row.supportCoin.map(item => item.coin).join(', ')
        }}</template>
      </el-table-column>
      <el-table-column prop="nowAmount" label="当前量"></el-table-column>
      <el-table-column prop="totalAmount" label="总量"></el-table-column>
      <el-table-column prop="openPrice" label="开盘价格">
        <template slot-scope="scope">
          <a v-if="scope.row.status == 2" @click="setOpenPrices(scope.row.id)">
            {{ scope.row.openPrice }}
            <i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="status  " label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">{{
            scope.row.__status.text
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="开始时间">
        <template slot-scope="scope">
          <span>{{ scope.row.startTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束时间">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="210">
        <template slot-scope="scope">
          <el-tooltip content="查看">
            <el-button
              type="info"
              size="small"
              circle
              icon="el-icon-view"
              @click="viewDetail(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="内容设置">
            <el-button
              type="primary"
              size="small"
              circle
              icon="el-icon-edit"
              @click="viewContent(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="增加人次">
            <el-button
              type="danger"
              size="small"
              circle
              icon="el-icon-setting"
              @click="
                addpeople(
                  scope.row.id,
                  scope.row.fPersonNum,
                  scope.row.tPersonNum
                )
              "
            ></el-button>
          </el-tooltip>
          <el-tooltip content="抽奖记录">
            <router-link
              :to="`/home/purchase/discountRecords/${scope.row.id}`"
              class="link-button"
            >
              <el-button
                type="success"
                size="small"
                circle
                icon="el-icon-tickets"
              ></el-button>
            </router-link>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    ></pagination>
    <detail @refresh="handleCurrentChange({ page: 1 })"></detail>
    <detail-content
      @refresh="handleCurrentChange({ page: 1 })"
    ></detail-content>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Pagination from 'components/pagination';
import Detail from '../detail';
import DetailContent from '../detailContent';

export default {
  name: 'discount',
  computed: {
    ...mapState('discount', ['totalCount', 'pagination']),
    ...mapGetters('discount', ['projectList'])
  },
  components: {
    Pagination,
    Detail,
    DetailContent
  },
  methods: {
    ...mapMutations('discount', [
      'setEditingProject',
      'setEditingContentProject'
    ]),
    ...mapActions('discount', [
      'getWinningRate',
      'setOpenPrice',
      'Addpeople',
      'getList'
    ]),
    viewDetail(project) {
      this.setEditingProject(project);
    },
    viewContent(project) {
      this.setEditingContentProject(project);
    },
    addpeople(id, fa, tr) {
      this.$prompt(`当前虚拟人次：${fa}，当前真实人次：${tr}`, '本次增加人次', {
        inputValidator: value => {
          return !value || !value.trim() ? '本次增加人次' : true;
        }
      }).then(({ value }) => {
        this.Addpeople({ purchaseId: id, personNum: Number(value) }).then(
          () => {
            this.$message.success('操作成功！');
            this.getList({
              type: 1,
              ...this.pagination
            });
            this.$emit('refresh', pagination);
          }
        );
      });
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    setOpenPrices(id) {
      this.$prompt('开盘价格', '设置', {
        inputValidator: value => {
          return !value || !value.trim() ? '开盘价格' : true;
        }
      }).then(({ value }) => {
        this.setOpenPrice({ purchaseId: id, openPrice: Number(value) }).then(
          () => {
            this.$message.success('操作成功！');
            this.$emit('refresh', pagination);
          }
        );
      });
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin-left: 10px;
}
</style>
